<template>

 <div v-for="(v,index) in inventory_arr" track-by="$Index">
<!-- Inventory Card Starts -->
        <div id='inventory'>
            <h6 class="yellow-section ml-2" style="background-color: #e0f1fc">
                <span class="voucher-label">{{inventory_key}}</span>
                <span><button id="ALLINVENTORYENTRIES_delete_button"
                        @click="delete_element(index)"
                        class="inventory-submit-btn ml-2" style="float:right;"
                        type="submit">-</button></span>
                <span><button style="float:right;"
                        @click="accountallocation(v)" type="submit"
                        class="inventory-submit-btn ml-2">Ledgers</button></span>
                <span><button style="float:right;" @click="batchallocation(v)"
                        type="submit"
                        class="inventory-submit-btn">Batch</button></span>
            </h6>
            
            <!---DevExtreme control start--->
            <div class="mx-3 m-1">
                <div class="dx-field">
                    <div class="dx-field-label">STOCKITEM NAME:</div>
                        <div class="dx-field-value">
                            <DxSelectBox :data-source="Headers" 
                            :value="v.STOCKITEMNAME"
                            :accept-custom-value="true"
                            v-model:selectedItem="v.STOCKITEMNAME"
                            />
                        </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">ACTUALQTY:</div>
                        <div class="dx-field-value">
                            <DxSelectBox :data-source="Headers" v-model:selectedItem="v.ACTUALQTY" :accept-custom-value="true" :value="v.ACTUALQTY"/>
                        </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">BILLEDQTY:</div>
                        <div class="dx-field-value">
                            <DxSelectBox :data-source="Headers" v-model:selectedItem="v.BILLEDQTY" :accept-custom-value="true" :value="v.BILLEDQTY"/>
                        </div>
                </div>
                 <div class="dx-field">
                    <div class="dx-field-label">AMOUNT:</div>
                        <div class="dx-field-value">
                            <DxSelectBox :data-source="Headers" v-model:selectedItem="v.AMOUNT" :accept-custom-value="true" :value="v.AMOUNT"/>
                        </div>
                </div>
                 <div class="dx-field">
                    <div class="dx-field-label">RATE:</div>
                        <div class="dx-field-value">
                            <DxSelectBox :data-source="Headers" v-model:selectedItem="v.RATE" :accept-custom-value="true" :value="v.RATE"/>
                        </div>
                </div>
                 <div class="dx-field">
                    <div class="dx-field-label">ISDEEMEDPOSITIVE:</div>
                        <div class="dx-field-value">
                            <DxSelectBox 
                            :data-source="is_deemed_positive1" 
                            display-expr="label"
                            value-expr="value"
                            v-model:selectedItem="v.ISDEEMEDPOSITIVE" 
                            :accept-custom-value="true" 
                            :value="v.ISDEEMEDPOSITIVE"
                            />
                        </div>
                </div>
                <!---DevExtreme control Ends--->
            </div>
            <div v-for="(v1,k1) in v ">
                <div v-show="k1=='ACCOUNTINGALLOCATIONS'">
                    <accountingallocations :is_deemed_positive1="is_deemed_positive1" :accounting_allocation_arr="v1" :accounting_allocation_key="k1" :Headers="Headers" :Headers_cust="Headers_cust" :ledger_names="ledger_names" />
                </div>
                <div v-show="k1=='BATCHALLOCATIONS'">
                     <batchallocations :is_deemed_positive1="is_deemed_positive1" :batch_allocation_arr="v1" :batch_allocation_key="k1" :Headers="Headers" :Headers_cust="Headers_cust" />
                </div>
            </div>
        </div>
 <!-- Inventory card ends -->
 </div>
</template>
<script>
import DxSelectBox from 'devextreme-vue/select-box';
import accountingallocations from './accountingallocations'
import batchallocations from './batchallocations'
export default {
    name:"inventory_entry",
    components:{
        DxSelectBox,
        batchallocations,
        accountingallocations
    },
    props: {
        inventory_arr:[],
        Headers:[],
        ledger_names:[],
        is_deemed_positive:{},
        is_deemed_positive1:[],
        inventory_key:'', 
        Headers_cust:[]
    },
    data:function(){
        return{
            Headers:[]
        }
    },
    methods:{
        accountallocation(value){
            this.$emit('accountallocation',value)
        },
        batchallocation(value){
            this.$emit('batchallocation',value)
        },
        delete_element(index){
            this.inventory_arr.splice(index,1)
        }


    }
}

</script>
<style>
.name{
     margin-left: 8rem; 
    margin-right:5rem ;
  }
  @media (max-width: 640px) {
 .font{
     font-size: 11px;
 }  
 }
</style>
